// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__3lZO0","main":"Layout_main__V716d"};